import React from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';

import { compose, withProps } from 'recompose';

import { VenueLink } from 'modules/point-of-interest';

const enhance = compose(
  withProps(({ stop = {} }) => ({
    company_name: stop.address.company_name,
    address_line: stop.address.address_line,
    zipcode: stop.address.zipcode,
    city: stop.address.city,
    gid: stop.address.gid,
    latitude: stop.address.latitude,
    longitude: stop.address.longitude,
    country: stop.address.country,
    addressId: stop.address.id,
  }))
);

const AddressRow = React.memo(
  ({
    className,
    company_name,
    address_line,
    zipcode,
    city,
    gid,
    latitude,
    longitude,
    country,
    showCountry,
    addressId,
  }) => (
    <StyledRow className={className}>
      <strong>{company_name}</strong>
      <div>{address_line}</div>
      <div>
        {showCountry && <span>{country} </span>}
        {zipcode} - {city}
      </div>
      <VenueLink gid={gid} latitude={latitude} longitude={longitude} addressId={addressId} />
    </StyledRow>
  )
);

AddressRow.propTypes = {
  company_name: PropTypes.string,
  address_line: PropTypes.string,
  zipcode: PropTypes.string,
  city: PropTypes.string,
  className: PropTypes.string,
};

AddressRow.defaultProps = {
  stop: {},
  className: '',
};

export default enhance(AddressRow);
